'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002499 from "./presto.types$$anon$99.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$98() {
  this.c37 = null;
  this.c2Z = null;
  this.c30 = false;
  this.c38 = null;
  this.c39 = false;
  this.c3c = null;
  this.c35 = null;
  this.c36 = false;
  this.c31 = null;
  this.c32 = false;
  this.c33 = null;
  this.c34 = false;
  this.c3a = false;
  this.c3b = false;
  this.c37 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c3c = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$98 as $c_Lpresto_types$$anon$98 };
$p = $c_Lpresto_types$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$98;
/** @constructor */
function $h_Lpresto_types$$anon$98() {
}
export { $h_Lpresto_types$$anon$98 as $h_Lpresto_types$$anon$98 };
$h_Lpresto_types$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c37;
});
$p.M = (function() {
  if ((!this.c30)) {
    this.c2Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c30 = true;
  }
  return this.c2Z;
});
$p.O = (function() {
  if ((!this.c39)) {
    this.c38 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c39 = true;
  }
  return this.c38;
});
$p.E = (function() {
  return this.c3c;
});
$p.t = (function() {
  if ((!this.c36)) {
    this.c35 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c36 = true;
  }
  return this.c35;
});
$p.N = (function() {
  if ((!this.c32)) {
    this.c31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c32 = true;
  }
  return this.c31;
});
$p.Q = (function() {
  if ((!this.c34)) {
    this.c33 = new $j_presto$002etypes$0024$0024anon$002499.$c_Lpresto_types$$anon$99();
    this.c34 = true;
  }
  return this.c33;
});
$p.v = (function() {
  if ((!this.c3b)) {
    this.c3a = false;
    this.c3b = true;
  }
  return this.c3a;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee140) => ((p) => \u03b4scrutinee140.cqV(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$98, "presto.types$$anon$98", ({
  YI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$98 as $d_Lpresto_types$$anon$98 };
//# sourceMappingURL=presto.types$$anon$98.js.map
